<template>
    <div v-if="!load">
        <div class="spacer"></div>
        <div class="col-md-8 col-sm-12 container">
            <div class="d-flex align-items-top">
                <RouterLink :to="{name: 'Dashboard'}" class="fa-2x fas text-info text-decoration-none fa-arrow-alt-circle-left mr-2"></RouterLink>
                <h1 class="h3">Editar equipo</h1>
            </div>
            <form @submit.prevent="doSubmit" class="lead mt-4">
                <div v-for="(a, i) in team" :key="i">
                    <div class="card bg-light card-body form-group">
                        <div class="form-group">
                            <label for="">Imagen</label>
                            <input type="file" accept="image/png, image/jpeg" :ref="`inputImage${i}`" @change="selectImage($event, i)" class="form-control-file mt-3" :required="!team[i].image"> 
                        </div>
                        <div class="form-group">
                            <label for="">Nombre</label>
                            <input class="form-control" v-model="team[i].name" placeholder="Ingresa el nombre" type="text">
                        </div>
                        <div class="form-group">
                            <label for="">Descripcion</label>
                            <input class="form-control" v-model="team[i].description" placeholder="Ingresa la descripción" type="text">
                        </div>
                        <div class="form-group">
                            <span class="btn btn-danger" @click="team.splice(i, 1)">Eliminar</span>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <span @click="team.push({})" class="btn btn-primary"><i class="fa-plus fa-sm fas fa-fw mr-2"></i>Agregar nuevo miembro</span>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>
    </div>
    <div class="min-vh-100" v-else></div>
</template>

<script>
import {db} from '../../firebase'
export default {
    name:'EditTeam',
    async created(){
        const team = await db.collection('team').doc('data').get()
        this.team = team.data().team
        this.load = false
    },
    data(){
        return{
            selectedImage: '',
            load: true,
            team: [
                {

                },
            ],
        }
    },
    methods:{
        async selectImage(event, i){
            const file = event.target.files[0]
            if(file){
                if(file.type == 'image/png' || file.type == 'image/jpeg'){
                    this.team[i].image = await this.$store.dispatch('utils/uploadImageAndGetUrl', {directory: `team/image/${file.name}-${Date.now()}`, image: file})
                }else{
                    this.$toast.error('El tipo de archivo seleccionado no es válido')
                }
            }
        },
        doSubmit(){
            try{
                const team = db.collection('team').doc('data')
                team.set({
                    team: this.team
                })
                this.$toast.success('El equipo fue actualizado')
                this.$router.push({name: 'Dashboard'})
            }catch(error){
                this.$toast.error('Hubo un problema al actualizar el equipo, intenta nuevamente más tarde')
            }
        },
    }
}
</script>